export const pendingCancelDescription =
  'Está ação irá cancelar o termo pendente.\nDeseja continuar mesmo assim?';
export const activeCancelDescription =
  'Está ação irá encerrar o modelo atual de feefixo do cliente.\nDeseja continuar mesmo assim?';
export const updateTermDescription =
  'Ao confirmar a substituição, o termo atual será substituído pelo novo.';
